import * as auth from './auth';
import * as builders from './builders';
import * as corporations from './corporations';
import * as subdivisions from './subdivisions';
import * as feeds from './feeds';
import * as lots from './lots';
import * as plans from './plans';
import * as globalMsg from './global-msg';
import * as globalModal from './global-modal';
import * as corporationFeeds from './corporation-feeds';
import * as reports from './reports';

export default {
	auth,
	builders,
	corporations,
	subdivisions,
	feeds,
	lots,
	plans,
	globalMsg,
	globalModal,
	corporationFeeds,
	reports,
};



// WEBPACK FOOTER //
// ./src/assets/js/actions/index.js